<template>
  <form-field-select
    v-model="value"
    :label="label"
    @input="handleInput"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    :validation-errors="validationErrors"
    :help-text="helpText"
  >
    <option v-if="includeNoStatus" :value="null">None</option>
    <optgroup label="Contact Not Made">
      <option
        v-for="status in statusesForContacting"
        :key="status.id"
        :value="status.id"
      >{{ status.label }}
      </option>
    </optgroup>

    <optgroup label="Active">
      <option
        v-for="status in statusesForActive"
        :key="status.id"
        :value="status.id"
      >{{ status.label }}
      </option>
    </optgroup>

    <optgroup label="Follow Up">
      <option
        v-for="status in statusesForFollowUp"
        :key="status.id"
        :value="status.id"
      >{{ status.label }}
      </option>
    </optgroup>

    <optgroup label="Completed">
      <option
        v-for="status in statusesForCompleted"
        :key="status.id"
        :value="status.id"
      >{{ status.label }}
      </option>
    </optgroup>

    <optgroup label="Dead">
      <option
        v-for="status in statusesForDead"
        :key="status.id"
        :value="status.id"
      >{{ status.label }}
      </option>
    </optgroup>

    <optgroup label="Non Lead">
      <option
        v-for="status in statusesForNonLead"
        :key="status.id"
        :value="status.id"
      >{{ status.label }}
      </option>
    </optgroup>
  </form-field-select>
</template>

<script>
export default {
  name: "FormFieldSelectStatus",
  props: {
    value: {},
    label: {
      type: String,
      default: "Status"
    },
    includeNoStatus: {
      type: Boolean,
      default: false,
    },
    validationErrors: {
      type: Array,
      default: () => [],
    },
    helpText: {
      type: String
    },
  },
  // vue 2.3+ sync prop value from parent and ability to manually select other value
  // without throwing an error about mutating prop value
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  // data() {
  //   return {
  //     statusId: this.value
  //   };
  // },
  computed: {
    statusesForContacting() {
      return this.$store.getters['pipeline/contactingStatuses'];
    },
    statusesForActive() {
      return this.$store.getters['pipeline/activeStatuses'];
    },
    statusesForFollowUp() {
      return this.$store.getters['pipeline/followUpStatuses'];
    },
    statusesForCompleted() {
      return this.$store.getters['pipeline/completedStatuses'];
    },
    statusesForDead() {
      return this.$store.getters['pipeline/deadStatuses'];
    },
    statusesForNonLead() {
      return this.$store.getters['pipeline/nonLeadStatuses'];
    },
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.$emit('updateValue', val)
    },
  }
};
</script>
